import { render, staticRenderFns } from "./cya_spu_selector.vue?vue&type=template&id=5a292696&scoped=true"
import script from "./cya_spu_selector.vue?vue&type=script&lang=js"
export * from "./cya_spu_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a292696",
  null
  
)

export default component.exports